var parent = require('../../stable/symbol');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/symbol/index.js
// module id = 401
// module chunks = 0 1